import React, { useState, useEffect } from 'react'
import { ButtonToolbar, Checkbox, Icon, Row, Table } from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function DataImportTable({
  schema,
  loading,
  onCancel = () => {},
  onSave = () => {},
  type,
}) {
  const { control } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])
  const [indeterminate, setIndeterminate] = useState(false)
  const [countSelected, setCountSelected] = useState(0)

  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    setTableData(schema)
  }, [schema])

  const autoCheckAll = () => {
    let checkedKeys

    if (type == 'imp03') {
      checkedKeys = tableData?.filter((e) => !e.isDupplicate)?.map((item) => item.projectCode)
    } else {
      checkedKeys = tableData?.map((item) => item.projectCode)
    }
    setIndeterminate(false)
    setCheckedKeys(checkedKeys)
    setCountSelected(checkedKeys.length)
  }

  const handleCheckAll = (value, checked) => {
    let checkedKeys

    if (type == 'imp03') {
      checkedKeys = checked
        ? tableData?.filter((e) => !e.isDupplicate)?.map((item) => item.projectCode)
        : []
    } else {
      checkedKeys = checked ? tableData?.map((item) => item.projectCode) : []
    }
    setIndeterminate(false)
    setCheckedKeys(checkedKeys)
    setCountSelected(checkedKeys.length)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    let allCount =
      type == 'imp03' ? tableData?.filter((e) => !e.isDupplicate).length : tableData?.length

    if (nextCheckedKeys.length != allCount) {
      setIndeterminate(true)
    } else {
      setIndeterminate(false)
    }
    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
            disabled={type == 'imp03' && rowData.isDupplicate}
          />
          {/* <b
            style={{
              color: rowData.isDupplicate ? '#fb8a81' : '',
            }}
          > */}
          {props.rowIndex + 1}
          {/* </b> */}
        </div>
      </Cell>
    )
  }

  const handleSave = () => {
    let newArr = []
    tableData.map((item) => {
      if (checkedKeys.includes(item.projectCode)) {
        newArr.push(item)
      }
    })
    // console.log('ggggg ', newArr)
    onSave(newArr)
  }

  return (
    <>
      <Table
        wordWrap
        height={800}
        autoHeight={tableData?.length < 10}
        headerHeight={fs <= 18 ? 40 : 50}
        loading={loading}
        data={tableData || []}
        style={{ marginTop: '20px' }}
        // affixHeader
        // rowClassName={(rowData) => {
        //   console.log('ggggg => ', rowData)
        //   if (rowData?.isDupplicate) {
        //     return 'karya-table-row'
        //   }
        // }}
        onDataUpdated={() => {
          autoCheckAll()
        }}
      >
        <Column width={100} align="center">
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: '40px' }}>
              <Controller
                name="chkRow"
                control={control}
                render={(props) => {
                  // if (isEditMode) {
                  //   return 'ลำดับ'
                  // }
                  return (
                    <Checkbox
                      inline
                      checked={props.value}
                      indeterminate={indeterminate}
                      onChange={(e, checked) => {
                        props.onChange(checked)
                        handleCheckAll(null, checked)
                      }}
                      style={{ marginLeft: -10 }}
                    >
                      <b>ลำดับ</b>
                    </Checkbox>
                  )
                }}
              />
            </div>
          </HeaderCell>

          <CheckCell
            dataKey="projectCode"
            checkedKeys={checkedKeys}
            onChange={(value, checked) => {
              handleCheck(value, checked)
            }}
          />
        </Column>

        <Column width={180} align="center">
          <HeaderCell>ปีงบประมาณ</HeaderCell>
          <Cell dataKey="budgetYear" />
        </Column>

        <Column width={180} align="center">
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        {type == 'imp02' && (
          <Column width={250}>
            <HeaderCell>ทีม</HeaderCell>
            <Cell dataKey="auditTeam" />
          </Column>
        )}
        {type == 'imp02' && (
          <Column width={250}>
            <HeaderCell>หัวหน้าทีมตรวจสอบ</HeaderCell>
            <Cell dataKey="auditHeader" />
          </Column>
        )}
        {type == 'imp02' && (
          <Column width={250}>
            <HeaderCell>อีเมลติดต่อ</HeaderCell>
            <Cell dataKey="auditEmail" />
          </Column>
        )}
        {type == 'imp02' && (
          <Column width={200}>
            <HeaderCell>เบอร์โทรศัพท์ติดต่อ</HeaderCell>
            <Cell dataKey="auditPhone" />
          </Column>
        )}
        {type == 'imp02' && (
          <Column width={350}>
            <HeaderCell>ที่อยู่ติดต่อ</HeaderCell>
            <Cell dataKey="auditAddress" />
          </Column>
        )}

        {type == 'imp03' && (
          <Column flexGrow={1}>
            <HeaderCell>เกรด</HeaderCell>
            <Cell dataKey="grade" />
          </Column>
        )}

        <Column width={fs <= 18 ? 250 : 350} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          {/* <Cell dataKey="projectCode" /> */}
          <Cell>
            {(rowData, index) => {
              return (
                <p style={{ color: rowData.isDupplicate ? '#fb8a81' : '' }}>
                  {rowData.isDupplicate ? (
                    <>
                      <Icon
                        icon="exclamation-circle2"
                        style={{ color: rowData.isDupplicate ? '#fb8a81' : '', marginRight: 10 }}
                      />
                      {type == 'imp03'
                        ? 'รายการนี้ไม่สามารถแก้ไขเกรด'
                        : 'รายการนี้มีข้อมูลอยู่แล้ว'}
                      {/* โครงการนี้มีการตรวจสอบในปีงบประมาณที่ระบุแล้ว */}
                    </>
                  ) : (
                    ''
                  )}
                </p>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <Row style={{ marginTop: 20 }}>
        {/* <hr /> */}
        <ButtonToolbar style={{ textAlign: 'right' }}>
          <SaveButton
            disabled={countSelected == 0}
            onClick={() => {
              handleSave()
            }}
          >
            {`บันทึก ${countSelected} รายการ`}
          </SaveButton>

          <CancelButton
            onClick={() => {
              onCancel()
            }}
          >
            {'ยกเลิก'}
          </CancelButton>
        </ButtonToolbar>
      </Row>
    </>
  )
}
